var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',{attrs:{"inline":""}},[_c('b-form-group',{attrs:{"description":_vm.message}},[_c('b-form-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0 text-center w-100",staticStyle:{"min-width":"350px"},attrs:{"placeholder":"Caption"},model:{value:(_vm.caption),callback:function ($$v) {_vm.caption=$$v},expression:"caption"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }